// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"withImages_wrapper__3MRcf"};